export const privacyPolicy = (
  <>
    <p>
      <strong>Effective date: July 13, 2026</strong>
    </p>
    <p>
      Listino provides research assistance and editable listing-preparation materials for real
      estate professionals. This notice explains the information we process, why we process it, the
      providers involved, and the choices available to you. Contact{" "}
      <a href="mailto:privacy-rights@listino.ai">privacy-rights@listino.ai</a> with questions or
      privacy requests.
    </p>
    <h4>Information we process</h4>
    <ul>
      <li>
        Account information such as name, email, brokerage profile, branding, and login records.
      </li>
      <li>
        Listing inputs such as an address, property facts, seller or agent notes, listing copy,
        photos, imported listing URLs, selected comparables, listing-prep edits, and feedback.
      </li>
      <li>
        Order and subscription records. Stripe processes full payment-card details; Listino receives
        transaction, customer, subscription, and payment-status identifiers rather than full card
        numbers.
      </li>
      <li>
        Product, device, security, and diagnostic data such as IP address, browser, timestamps,
        route activity, bounded product events, errors, and service logs.
      </li>
    </ul>
    <h4>How we use information</h4>
    <p>
      We use this information to create and edit listing preps; research candidate properties;
      generate text and image outputs; process orders; authenticate accounts; deliver email; provide
      sharing, support, fraud prevention, quality review, analytics, and service monitoring; enforce
      our terms; and comply with law. We do not sell personal information. We do not use listing or
      listing-prep content for third-party targeted advertising.
    </p>
    <h4>Automated and generative-AI processing</h4>
    <p>
      Listing text, instructions, property facts, and photos may be sent to Google Gemini and
      related Google generative-AI services to draft analysis, copy, image recommendations, and
      edited images. Generated material can be inaccurate or inappropriate and must be reviewed by
      the agent before client use. Do not submit confidential information that is unnecessary for
      the listing prep.
    </p>
    <h4>Service providers and external sources</h4>
    <ul>
      <li>
        AWS provides application hosting, databases, object storage, queues, email, logging, and
        related infrastructure.
      </li>
      <li>Stripe provides checkout, subscription, fraud, payment, and billing-portal services.</li>
      <li>
        Google provides Gemini/generative-AI processing and, when enabled, Tag Manager analytics.
      </li>
      <li>
        Zillow, RapidAPI providers, brokerage/listing sites, assessor sources, and other publicly
        accessible web sources may be queried to import or research property information.
      </li>
      <li>
        Listino's first-party analytics records allowlisted, bounded product events. Google Tag
        Manager may also receive browser analytics when enabled by our deployment and your browser
        settings.
      </li>
    </ul>
    <p>
      Providers process data under their own terms and privacy notices and may operate in locations
      outside your state or country. We may also disclose information when required by law, to
      protect users and the service, or as part of a business transaction subject to appropriate
      safeguards.
    </p>
    <h4>Owner-controlled listing-prep sharing</h4>
    <p>
      Finished listing preps are private to the account owner unless the owner exports a file or
      creates a share link. A share link contains a random token and lets anyone who receives it
      view the published listing prep and available files without signing in. We do not list these
      links publicly, but recipients can forward them. Owners can revoke Listino links from the
      Share page. Revocation prevents future link access but cannot recall downloaded or forwarded
      copies. Listing preps can contain an address, photos, branding, and owner-entered content;
      remove confidential seller information before publishing.
    </p>
    <h4>Retention</h4>
    <p>
      We retain account, listing, listing-prep, transaction, feedback, security, and support
      information for as long as reasonably needed to provide the service, maintain version history,
      meet legal and accounting obligations, resolve disputes, prevent abuse, and maintain backups.
      Retention varies by data type and operational need. You may request account deletion; some
      transaction, security, backup, or legal records may be retained where required or reasonably
      necessary.
    </p>
    <h4>Your choices and rights</h4>
    <p>
      You can edit profile and listing-prep information, revoke share links, and opt out of
      non-essential marketing email through the message or by contacting us. Depending on where you
      live, you may have rights to access, correct, delete, restrict, object to, or receive a copy
      of personal information. We may need to verify your identity before fulfilling a request. You
      may appeal a denied request by replying to our decision.
    </p>
    <h4>Security and children</h4>
    <p>
      We use administrative, technical, and organizational safeguards designed to protect data, but
      no internet service is completely secure. Listino is for real estate professionals and is not
      directed to children under 18. Contact us if you believe a child submitted information.
    </p>
    <h4>Changes</h4>
    <p>
      We may update this notice as the product or providers change. We will update the effective
      date and provide additional notice when required by law.
    </p>
  </>
);
